<template>
  <div class="login-container">
    <!-- 企微免登进行中：以遮罩卡片代替登录表单，避免闪现账号密码框 -->
    <div v-if="wecomAutoLogin" class="login-box wecom-auto-login">
      <i class="el-icon-loading wecom-auto-login-icon"></i>
      <p class="wecom-auto-login-text">正在使用企业微信账号自动登录…</p>
    </div>
    <div v-else class="login-box">
      <div class="login-header">
        <img src="../assets/logo.png" alt="Logo" class="logo">
        <h1 class="system-name">{{title}}</h1>
      </div>
      <div class="login-form">
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" @submit.native.prevent>
          <el-form-item prop="account">
            <el-input
              v-model="loginForm.account"
              prefix-icon="el-icon-user"
              placeholder="请输入用户名">
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              prefix-icon="el-icon-lock"
              type="password"
              placeholder="请输入密码">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="login-button"  native-type="submit" @click="submitForm('loginForm')">
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="login-footer">
        <p>© 2025 {{nickName}} 版权所有</p>
        <p class="icp-info">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">陕ICP备2025075677号-2</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  data () {
    return {
      loginForm: {
        account: '',
        password: ''
      },
      loginRules: {
        account: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 5, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      },

      nickName: '飞鸟餐赢',
      title: '飞鸟中台管理系统',
      wecomAutoLogin: false
    }
  },
  created () {
    // 已登录用户（含企微内重复进入）直达系统，忽略残留 code
    if (window.sessionStorage.getItem('token')) {
      this.$router.push('/welcome')
      return
    }

    // 企微 OAuth 回跳会把 code 拼在 hash 路由之外的外层 query，须从 location.search 读取
    const code = new URLSearchParams(window.location.search).get('code')
    if (code) {
      this.wecomAutoLogin = true
      this.wecomLogin(code)
    } else if (/wxwork/i.test(navigator.userAgent)) {
      // 企微内置浏览器（PC/手机）：先取免登跳转参数（后端凭证统一下发），再跳 OAuth 静默授权
      this.startWecomOauth()
    }
  },

  methods: {

    // 拉取免登跳转参数（corpId/agentId，corpId 配置即生效不写死前端）；失败或未配置回落账号密码表单
    async startWecomOauth () {
      this.wecomAutoLogin = true
      try {
        const { data: res } = await this.$http.get('wecom/oauth/config')
        if (res.meta.status !== 200 || !res.data.corpId || !res.data.agentId) {
          throw new Error(res.meta.msg || '企微免登未配置')
        }
        // redirect_uri 用裸域（hash 路由），code 由后端从外层 query 读取
        const redirectUri = encodeURIComponent(`${window.location.origin}/`)
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize' +
          `?appid=${res.data.corpId}&redirect_uri=${redirectUri}` +
          '&response_type=code&scope=snsapi_base&state=feiniao' +
          `&agentid=${res.data.agentId}#wechat_redirect`
      } catch (e) {
        console.error('[企微免登] 跳转参数获取失败，回落账号密码登录', e)
        this.wecomAutoLogin = false
      }
    },

    // 企微免登：code 换登录态，成功走与密码登录一致的会话写入
    async wecomLogin (code) {
      // 立即清掉外层 query（保留 hash），防止刷新/回退重复消费已失效的 code
      window.history.replaceState(null, '', window.location.pathname + window.location.hash)

      const { data: res } = await this.$http.get('login/wecom', { params: { code } })
      if (res.meta.status !== 200) {
        // 免登失败：撤掉遮罩回落到账号密码表单兜底
        this.wecomAutoLogin = false
        return this.$message.error(res.meta.msg)
      }

      this.$message.success('登录成功')
      window.sessionStorage.setItem('base', res.meta.base)
      window.sessionStorage.setItem('token', res.data.token)
      window.sessionStorage.setItem('account', res.data.account)
      window.sessionStorage.setItem('accountId', res.data._id)
      window.sessionStorage.setItem('name', res.data.name)
      window.sessionStorage.setItem('level', res.data.level)
      window.sessionStorage.setItem('employeeId', res.data.employeeId || '')
      window.sessionStorage.setItem('employeeName', res.data.employeeName || '')
      window.sessionStorage.setItem('department', res.data.department || '')
      window.sessionStorage.setItem('job', res.data.job || '')
      window.sessionStorage.setItem('bindDxqId', res.data.bindDxqId || '')
      window.sessionStorage.setItem('activePath', '/home')
      this.$router.push('/welcome')
    },

    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // 这里添加登录逻辑
          const { data: res } = await this.$http.get('login', {
            params: this.loginForm
          })
          if (res.meta.status !== 200) {
            return this.$message.error(res.meta.msg)
          }

          this.$message.success('登录成功')
          // 登录成功后跳转到首页
          window.sessionStorage.setItem('base', res.meta.base)
          window.sessionStorage.setItem('token', res.data.token)
          window.sessionStorage.setItem('account', res.data.account)
          window.sessionStorage.setItem('accountId', res.data._id)
          window.sessionStorage.setItem('name', res.data.name)
          window.sessionStorage.setItem('level', res.data.level)
          window.sessionStorage.setItem('employeeId', res.data.employeeId || '')
          window.sessionStorage.setItem('employeeName', res.data.employeeName || '')
          window.sessionStorage.setItem('department', res.data.department || '')
          window.sessionStorage.setItem('job', res.data.job || '')
          window.sessionStorage.setItem('bindDxqId', res.data.bindDxqId || '')
          window.sessionStorage.setItem('activePath', '/home')
          this.$router.push('/welcome')
        } else {
          this.$message.error('请正确填写登录信息')
          return false
        }
      })
    }

  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url('../assets/bk.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
}

.login-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.login-box {
  width: 400px;
  padding: 40px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 10;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.logo {
  width: 80px;
  height: 80px;
  margin-bottom: 15px;
  border-radius: 15px;
}

.system-name {
  font-size: 24px;
  color: #303133;
  margin: 0;
  font-weight: 500;
}

.login-form {
  margin-bottom: 30px;
}

.login-button {
  width: 100%;
  padding: 12px 0;
  font-size: 16px;
}

.login-footer {
  text-align: center;
  color: #606266;
  font-size: 14px;
}

.wecom-auto-login {
  text-align: center;
}

.wecom-auto-login-icon {
  font-size: 36px;
  color: #409EFF;
}

.wecom-auto-login-text {
  margin: 18px 0 0 0;
  font-size: 15px;
  color: #606266;
}

.icp-info {
  margin: 5px 0 0 0;
  color: #909399;
  font-size: 12px;
}

.icp-info a {
  color: #909399;
  text-decoration: none;
}

.icp-info a:hover {
  color: #606266;
  text-decoration: underline;
}
*{
  box-sizing: border-box;
}
</style>
